//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../no/SelectLine.js";
import "../no/SelectObject.js";
let d=[[[0,"AngleEndPoint",1,"Point",0],[0,"AngleMethod",1,0],[0,"AnglePivotPoint",1,"Point",0],[0,"AngleStartPoint",1,"Point",0],[0,"AngleTolerance",1,0],[0,"AngleValue",1,0],[0,"ArrayAngle",1,0],[0,"ArrayCircularIncrementAngle",1,0],[0,"ArrayCircularNumber",1,0],[0,"ArrayCircularRadius",1,0],[0,"ArrayCircularStartAngle",1,0],[0,"ArrayNumberAlongXc",1,0],[0,"ArrayNumberAlongYc",1,0],[0,"ArrayOffsetXc",1,0],[0,"ArrayOffsetYc",1,0],[0,"ArrayOriginPoint",1,"Point",0],[0,"DeltaXc",1,0],[0,"DeltaYc",1,0],[0,"DeltaZc",1,0],[0,"DistanceAngleDivision",1,0],[0,"DistanceTolerance",1,0],[0,"LineEndPoint",1,"Point",0],[0,"LineMethod",1,0],[0,"LinePoint",1,"Point",0],[1,"LineSelection",0,"SelectLine",0],[0,"LineStartPoint",1,"Point",0],[0,"LineVector",1,"Direction",0],[0,"MotionType",1,0],[0,"MoveCopyInstance",1,0],[0,"NumOfCopyInstance",1,0],[0,"Plane",1,"Plane",0],[0,"ReferencePoint",1,"Point",0],[0,"RepositionFromCsys",1,"CoordinateSystem",0],[0,"RepositionToCsys",1,"CoordinateSystem",0],[0,"ScaleFactor",1,0],[0,"ToPoint",1,"Point",0],[0,"TransformType",1,0]],[[[],"RemoveTransformation",{},0,0]],[]];
SPLM.CAM.InspectionOperationTransformBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionOperationTransformBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionOperationTransformBuilder.Transform = Object.freeze({
    "Translate" : "Translate", "Scale" : "Scale", "RotateAboutPoint" : "RotateAboutPoint", "RotateAboutLine" : "RotateAboutLine", "MirrorThroughALine" : "MirrorThroughALine", "MirrorThroughAPlane" : "MirrorThroughAPlane", "CircularArray" : "CircularArray", "RectangularArray" : "RectangularArray", "Reposition" : "Reposition"});

SPLM.CAM.InspectionOperationTransformBuilder.Motion = Object.freeze({
    "Delta" : "Delta", "ToAPoint" : "ToAPoint"});

SPLM.CAM.InspectionOperationTransformBuilder.Angle = Object.freeze({
    "Specify" : "Specify", "TwoPoint" : "TwoPoint"});

SPLM.CAM.InspectionOperationTransformBuilder.Line = Object.freeze({
    "Specify" : "Specify", "TwoPoint" : "TwoPoint", "PointAndVector" : "PointAndVector"});

SPLM.CAM.InspectionOperationTransformBuilder.Result = Object.freeze({
    "Move" : "Move", "Copy" : "Copy", "Instance" : "Instance"});

export default SPLM;